<!--*ngIf="latitude  && longitude " [latitude]="latitude" [longitude]="longitude" [label]="fulladress" -->
<q-leaf-map [Adresse]="fulladress" class="w-100 mt-2"></q-leaf-map>
